import { ProgressSpinner } from 'callahan-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'

import { fetchMobileApps } from '../../actions/mobile-apps-actions'
import BackButton from '../../components/BackButton'

import '../default.css'
import './mobile-apps.css'
import 'react-table/react-table.css'

const propTypes = {
  isRequestingMobileApps: PropTypes.bool,
  requestMobileAppsError: PropTypes.bool,
  mobileAppsData: PropTypes.array,
  pages: PropTypes.number
}

export class MobileApps extends Component {
  getSortQueryString = state => {
    let sortMethod = ''
    if (state.sorted[0]) {
      if (state.sorted[0].desc) {
        sortMethod = '-'
      }
      if (state.sorted[0].id === 'createdDatetime') {
        sortMethod += 'created'
      } else if (state.sorted[0].id === 'apiKey') {
        sortMethod += 'pcode'
      } else {
        sortMethod += state.sorted[0].id
      }
    } else {
      sortMethod = 'mau'
    }
    return sortMethod
  }

  render() {
    const columns = [
      { Header: 'Name', accessor: 'name', minWidth: 120 },
      { Header: 'p-code', accessor: 'pcode', minWidth: 100 },
      { Header: 'w-unit', accessor: 'wunit', minWidth: 200 },
      { Header: 'API key', accessor: 'apiKey', minWidth: 180 },
      { Header: 'Created Date', accessor: 'createdDatetime', minWidth: 120 },
      {
        Header: 'MAUs',
        accessor: 'mau',
        Cell: props => <span>{props.value ? props.value.toLocaleString() : 'No Data'}</span>
      }
    ]
    const { isRequestingMobileApps, mobileAppsData, pages } = this.props
    return (
      <div className="main-content">
        <div className="title-bar">
          <BackButton />
          <h1 className="page-title">Mobile Apps Report</h1>
          <div className="title-right-padding" />
        </div>
        <hr />
        {isRequestingMobileApps && (
          <ProgressSpinner size="small" className="mobile-apps-loading-table" />
        )}
        <ReactTable
          className="apps-data-table"
          data={mobileAppsData}
          pages={pages}
          columns={columns}
          manual={true}
          onFetchData={state => {
            let query = new URLSearchParams()
            query.append('offset', state.page * state.pageSize)
            query.append('pageSize', state.pageSize)
            query.append('sort', this.getSortQueryString(state))
            this.props.dispatch(fetchMobileApps(query.toString()))
          }}
        />
      </div>
    )
  }
}
MobileApps.propTypes = propTypes

function mapStateToProps(state) {
  const { mobileApps } = state
  return {
    isRequestingMobileApps: mobileApps.isRequestingMobileApps,
    requestMobileAppsError: mobileApps.requestMobileAppsError,
    mobileAppsData: mobileApps.data,
    pages: mobileApps.pages
  }
}

export default connect(mapStateToProps)(MobileApps)



// WEBPACK FOOTER //
// ./src/pages/MobileApps/MobileApps.js